module.exports = __webpack_public_path__ + "static/img/Billbergia.ab4b3548.png";